/**
 * @enum {string}
 */
export const UserType = {
  HYG: 'HYG',
  DNT: 'DNT',
};
